/**
 * Internacionalización mínima sin dependencias: claves con punto, interpolación {nombre}
 * y plurales con Intl. Pura: la usan la interfaz (con React) y el servidor (WhatsApp).
 */
import { es, type Messages } from './es';
import { en } from './en';

export type Locale = 'es' | 'en';
export const LOCALES: Locale[] = ['es', 'en'];
const catalogs: Record<Locale, Messages> = { es, en };

function lookup(obj: unknown, path: string): unknown {
  let cur = obj;
  for (const part of path.split('.')) {
    if (cur === null || typeof cur !== 'object') return undefined;
    cur = (cur as Record<string, unknown>)[part];
  }
  return cur;
}

export type TFn = (key: string, params?: Record<string, string | number>) => string;

export function capitalize(s: string): string {
  return s.charAt(0).toLocaleUpperCase() + s.slice(1);
}

/**
 * Plurales: "singular|plural" elegido con Intl.PluralRules sobre el parámetro `count`.
 */
export function makeT(locale: Locale): TFn {
  const tag = locale === 'es' ? 'es-ES' : 'en-US';
  const nf = new Intl.NumberFormat(tag, { maximumFractionDigits: 2 });
  const pr = new Intl.PluralRules(tag);
  return (key, params) => {
    const found = lookup(catalogs[locale], key) ?? lookup(catalogs.es, key);
    if (typeof found !== 'string') return key;
    let raw: string = found;
    if (raw.includes('|')) {
      const [one, other] = raw.split('|') as [string, string];
      raw = typeof params?.count === 'number' && pr.select(params.count) === 'one' ? one : (other ?? one);
    }
    if (!params) return raw;
    return raw.replace(/\{(\w+)\}/g, (_, name: string) => {
      const v = params[name];
      if (v === undefined) return `{${name}}`;
      return typeof v === 'number' ? nf.format(v) : v;
    });
  };
}

